import styled from 'styled-components';

import {colors} from 'theme';

export const TitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const FileZone = styled.div`
    border: 1px dashed ${colors.brandPrimary};
    box-sizing: border-box;
    border-radius: 3px;
    height: 193px;
    line-height: 193px;
    text-align: center;
    color: ${colors.brandPrimary};
    margin-top: 30px;
    margin-bottom: 50px;
`;
